<template>
  <div class="">
    <b-form-input v-model="addImageOnEditor" aria-placeholder="لینک عکس موردنظر را وارد کنید"/>
    <button type="button" class="btn btn-secondary btn-sm mr-2 mt-2 mb-2 rounded-pill"
            @click="addImage(addImageOnEditor)">اضافه کردن عکس
    </button>
  </div>
</template>

<script>
export default {
  name: "AddImageToEditor",
  props: {
    title: {
      default: ''
    }
  },
  data() {
    return {
      addImageOnEditor: '',
    }
  },
  methods: {
    addImage(image) {
      image = `<img src="${image}" class="col-lg-12" alt="${this.title.name}" />`;
      this.$emit('image-handler', image)
    },
  }
}
</script>

<style scoped>

</style>